export default __webpack_public_path__ + "static/media/sp_edit_deactive.f6cc4b7e.svg";